import inView from 'in-view';

const moduleName = 'animate';

export function animate() {

    Array.from(document.querySelectorAll('.js-animate')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const target = self;
        let windowWidth = document.body.clientWidth;

        if (windowWidth >= 768) {
            inView.offset(160);
        } else {
            inView.offset(80);
        }

        if (!inView.is(target)) {
            target.classList.add('_nodelay');
        }
        checkTargetVisibility();

        window.addEventListener('scroll', checkTargetVisibility);
        window.addEventListener('resize', setOffset);



        function setOffset() {
            const newWindowWidth = document.body.clientWidth;

            if (newWindowWidth >= 768 && windowWidth < 768) {
                inView.offset(160);
            } else if (newWindowWidth < 768 && windowWidth >= 768) {
                inView.offset(80);
            }

            windowWidth = newWindowWidth;
        }

        function checkTargetVisibility() {
            if (inView.is(target) && !target.classList.contains('_animated')) {
                target.classList.add('_animated');
            }
        }
    });

}